import { useEffect } from 'react';
import styles from './TypeProject.module.css'

export type TypeProjectProps = {
    type: string;
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
}

const TypeProject = (props: TypeProjectProps) => {
    const handleClick = () => {
        if (props.type === "") {
            props.setSearch('');
        } else if (props.search === props.type) {
            // Remove the type if it's already selected
            props.setSearch(
                ''
            );
        } else {
            // Add the type if it's not selected and remove "All" if present
            props.setSearch(
                props.type
            );
        }
    };
    const { search, setSearch } = props;

    useEffect(() => {
        if (search.length === 0) {
            setSearch("");
        }
    }, [search, setSearch]);

    return (
        <div
            className={`${styles.type} ${props.search === props.type ? styles.current_type : ''}`}
            onClick={handleClick}
        >
            {props.type === "" ? "All" : props.type}
        </div>
    );
}

export default TypeProject;
